export const GET_SDPU_STORE_INFO = 'GET_SDPU_STORE_INFO';
export const SET_STORE_INFO_TO_LOCAL_STORAGE = 'SET_STORE_INFO_TO_LOCAL_STORAGE';
